import {Component, OnInit} from '@angular/core';
import {FabricRepository} from '../../../repositories/fabric.repository';
import FabricInterface from '../../../models/fabric.interface';
import {InspirationRepository} from '../../../repositories/inspiration.repository';

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.css'],
})
export class HomePageComponent {
    public fabrics: FabricInterface[] = [];
    public inspirations: any[] = [];

    constructor(private fabricRepository: FabricRepository, private inspirationRepository: InspirationRepository) {
        const fabrics = fabricRepository.all();

        this.fabrics = ['sweat-rosa-gestreift', 'sweat-gitter-bordeaux', 'musselin-hasen-mint', 'sweat-mint-gestreift', 'wollwalk-kupfer']
            .map(id => fabrics.find(fabric => fabric.id === id))
            .filter(fabric => !!fabric);

        this.inspirations = inspirationRepository.all();
    }
}
